// extracted by mini-css-extract-plugin
module.exports = {"container":"_29-A6U48CAn5te0Vs2gez8","textContainer":"_3kBSvubixqvMsWYZ3FkJSj","title":"_17H8za0N8c8ghaN6f-zQ1D","subtitle":"_2B7Xt_3_qqAkgaFYw0RmT4"};